import { IDropdownSearchOption } from '@/components/common';
import { PROFILES_API_ENDPOINTS } from '@/constants';
import { ApiResponse } from '@/types';
import api from './api';
import { IFaceIdProfileDetails, IFaceIdProfileSearchResponse } from '@/interfaces';

const FaceIdProfileService = {
  GetFaceIdProfiles: async (
    searchValue: IDropdownSearchOption,
  ): Promise<ApiResponse<IFaceIdProfileSearchResponse>> => {
    const response = await api.post(PROFILES_API_ENDPOINTS.PROFILES_EMPLOYEES_CURSOR, searchValue);
    return response.data;
  },
  GetFaceIdProfile: async (id: string): Promise<ApiResponse<IFaceIdProfileDetails>> => {
    const response = await api.get(PROFILES_API_ENDPOINTS.PROFILES_ID.replace(':profileId', id));
    return response.data;
  },
};

export default FaceIdProfileService;
